import styled from 'styled-components';
import { colors } from 'styles/colors';

export const SelectButton = styled.div`
  margin-right: 12px;
  padding: 2px;
  border-radius: 3px;
  text-wrap: nowrap;
  width: 100%;
  color: ${colors.BlueSecondary};
  background-color:  ${colors.White};
  :hover {
    background-color: ${colors.GreyLight}
  })
`;
